export default __webpack_public_path__ + "static/media/image-banes.ab2fc558.svg";